/** Per-case file-save flags. A later case must not replace an earlier one. */

export function rememberHistoryFilesSkipped(store, queryId, skipped) {
  if (!queryId) return;
  if (skipped) store.set(queryId, true);
  else store.delete(queryId);
}

export function consumeHistoryFilesSkipped(store, queryId) {
  if (!queryId) return false;
  const skipped = store.get(queryId) === true;
  store.delete(queryId);
  return skipped;
}

/** True only when the poll that finished is still the case on screen. */
export function isActiveFinishedQuery(activeQueryId, finishedQueryId) {
  return Boolean(finishedQueryId) && activeQueryId === finishedQueryId;
}
